(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('ManageBrandModalController', ManageBrandModalController);

     ManageBrandModalController.$inject = [
           '$uibModalInstance',
           '$rootScope',
           'brand',
           'FlyersService',
           '$timeout',
           '$scope',
           '$window',
           '$translate',
           '$stateParams',
           'toastr',
           '$localStorage'
         ];

    function ManageBrandModalController($uibModalInstance,
                                        $rootScope,
                                        brand,
                                        FlyersService,
                                        $timeout,
                                        $scope,
                                        $window,
                                        $translate,
                                        $stateParams,
                                        toastr,
                                        $localStorage) {
        var vm = this;
        const MAX_IMAGE_SIZE = 10240;
        const UPLOAD_IMAGE_CONTEXT = "image";

        vm.brandData = angular.copy(brand) || { name: '', logo: '' };
        vm.isEdit = vm.brandData.isEdit;
        vm.isUploading = false;
        vm.totalImages = vm.brandData.logo ? 1 : 0;
        vm.isImmoContext = $localStorage.defaultStore.immoContext;

        if (vm.isEdit) {
            vm.title = "flyers.new.form.brand-modal.title-update";
            vm.button = "flyers.new.form.brand-modal.update";
        } else {
            vm.title = "flyers.new.form.brand-modal.title";
            vm.button = "flyers.new.form.brand-modal.add";
        }

        vm.openInput = function() {
            document.getElementById('upload-photo').click();
        };

        vm.handleLogoSelect = function(e) {
            var files = e.currentTarget.files;
            if (!files || !files.length) return;

            if (vm.totalImages >= 1) {
                toastr.error($translate.instant("flyers.messages.error.image.single-only"));
                e.currentTarget.value = null;
                return;
            }

            var file = files[0];

            if (file.size / 1024 > MAX_IMAGE_SIZE) {
                toastr.error($translate.instant("flyers.messages.error.image.limit-size"));
                e.currentTarget.value = null;
                return;
            }

            var validTypes = ['image/jpeg', 'image/png', 'image/webp'];
            if (validTypes.indexOf(file.type) === -1) {
                toastr.error($translate.instant("flyers.messages.error.image.file-type"));
                e.currentTarget.value = null;
                return;
            }

            vm.isUploading = true;
            var reader = new FileReader();

            reader.onload = function(e) {
                $scope.PreviewImage = e.target.result;

                var formData = new FormData();
                formData.append('file', file);
                formData.append('context', UPLOAD_IMAGE_CONTEXT);

                var config = {
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined }
                };
                FlyersService.uploadFile(file, UPLOAD_IMAGE_CONTEXT)
                    .then(function(response) {
                        if (response.data === null) {
                            toastr.error($translate.instant("flyers.messages.error.image.upload-failed"));
                        } else {
                            vm.brandData.logo = response.data.path;
                            vm.totalImages = 1;
                        }
                    })
                    .catch(function(error) {
                        if (error.data && error.data.description) {
                            if (error.data.description.includes("Unsupported file content type")) {
                                toastr.error($translate.instant("flyers.messages.error.image.file-type"));
                            } else if (error.data.description.includes("size limit")) {
                                toastr.error($translate.instant("flyers.messages.error.image.limit-size"));
                            } else {
                                toastr.error(error.data.description ||
                                    $translate.instant("flyers.messages.error.image.default"));
                            }
                        } else {
                            toastr.error($translate.instant("flyers.messages.error.image.default"));
                        }
                        e.currentTarget.value = null;
                    })
                    .finally(function() {
                        vm.isUploading = false;
                        e.currentTarget.value = null;
                    });
            };
            reader.readAsDataURL(file);
        };

        vm.removeBrandImage = function() {
            vm.brandData.logo = null;
            $scope.PreviewImage = null;

            vm.isUploading = false;
            vm.totalImages = 0;
        };

        vm.closeModal = function() {
            $uibModalInstance.dismiss(false);
        };

        vm.saveBrand = function() {
            $uibModalInstance.close(vm.brandData);
        };

        vm.getTranslateKey = function (baseKey) {
            return getTranslateKey(vm.isImmoContext, baseKey)
        };
    }
})();
